import HTTP from '../http'
import Appointment from './appointmentModel'
import { SEARCH, SEARCH_WITH_CLIENT } from './appointmentQueries'

const masterAppointmentSearch = (query: string, locationId: string, startDate: string, includeClient: boolean) => {
  if (!locationId) {
    throw new Error('The location_id is required')
  }
  let newStartDate = startDate
  if (!newStartDate) {
    const today = new Date()
    newStartDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
  }

  let variables: any = {
    location_id: Array.isArray(locationId) ? locationId : [ locationId ],
    start_date: newStartDate
  }
  if (includeClient) {
    variables.include_client = true
  }

  return HTTP.post('', {
    query: query,
    variables: variables
  }).then((res: any) => {
    const results = res.data.data.appointmentSearch.map((as: any) => new Appointment(as))
    return results
  })
}

const appointmentService = {
  search (locationId: string, startDate: string) {
    return masterAppointmentSearch(SEARCH, locationId, startDate, false)
  },
  searchWithClient (locationId: string, startDate: string) {
    return masterAppointmentSearch(SEARCH_WITH_CLIENT, locationId, startDate, true)
  }
}

export default appointmentService
